import { render } from "./how-to-be-more-productive-working-from-home.vue?vue&type=template&id=7a0fd348"
const script = {}
script.render = render

export default script